module.exports = "<div class=\"wrapper-stop-onboardiong\">\n  <alg-button\n      class=\"stop-onboarding-button\" \n      outline=\"false\"\n      variant=\"tertiary\"\n      type=\"button\"\n      [full]=\"true\"\n      (click)=\"openRecapModal()\">\n      <span class=\"suspend-label-mobile\" id=\"status-bar-save-button\">Vedi la tua offerta</span>\n    </alg-button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-header-button/alg-header-button.component.html
// module id = ./src/app/components/atoms/alg-header-button/alg-header-button.component.html
// module chunks = main